module.exports = __webpack_public_path__ + "static/media/cloud@2x.030d9a76.png";